"use strict";

class StationSettingsBearersFieldCtrl {
    constructor($rootScope, $scope, $state) {

        this.fieldtypes = [
            {name: 'FM'},
            {name: 'DAB'},
            {name: 'DRM'},
            {name: 'HDRadio'},
            {name: 'Internet'}
        ];

        this.parentCtrl = $scope.$parent.ctrl;

        //Wait until info is loaded
        $scope.$watch(() => {
            return this.parentCtrl.fields[$state.params.fieldId];
        }, (newVal) => {

            this.currentBearer = this.parentCtrl.fields[$state.params.fieldId];
        });

        $scope.$watch(() => {
            return $scope.bearerssettings.$invalid;
        }, (newVal) => {
            $rootScope.saveDisabled = newVal;
        });
    }

    processPiCode(value) {
        
        let piCodes = false;
        if (typeof this.parentCtrl.country_data != 'undefined') {
            piCodes = this.parentCtrl.country_data.gcc_code.split(';');
        }
        
        if (typeof value.$modelValue != 'undefined' && value.$modelValue.length == 4 && 
            (piCodes == false || piCodes.indexOf(value.$modelValue.charAt(0)) > -1)
        ) {
            value.$setValidity("invalid_pi", true);
            if (typeof this.parentCtrl.country_data != 'undefined') {
                this.currentBearer.gcc = value.$modelValue.charAt(0) + this.parentCtrl.country_data.gcc_ecc;
            } else {
                this.currentBearer.gcc = "XXX";
            }
        } else {
            value.$setValidity("invalid_pi", false);
        }
        
        
    }



}

StationSettingsBearersFieldCtrl.$inject = [
    '$rootScope',
    '$scope',
    '$state'
];

module.exports = StationSettingsBearersFieldCtrl;